import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Finish from "./finish";
import FinishSave from "./finish-save";
import { useData } from "../../util/dataProvider";

export default function UnternehmensForm() {
    const { createCompany, user, unternehmen, setUnternehmen } = useData();
    const [page, setPage] = useState(1);

    const initialValues = unternehmen
        ? unternehmen
        : {
              name: "",
              website: "",
              long_name: "",
              logo: "",
              header: "",
              focus: "",
              approved: false,
              street_number: "",
              description: "",
              zip: "",
              city: "",
              phone: "",
              email: "",
              founding: "",
              employees: "",
              fields: [],
              miscFocus: "",
              miscInterest: "",
              interested: [],
              user: user.uid,
              user_email: user.email,
              category: "unternehmen",
              contact: [
                  {
                      name: "",
                      position: "",
                      phone: "",
                      email: "",
                      image: "",
                  },
              ],
              datenschutz: false,
              oberkat: "",
              underkat: "",
          };
    if (!initialValues.contact) {
        initialValues.contact = [
            {
                name: "",
                position: "",
                phone: "",
                email: "",
                image: "",
            },
        ];
    }
    const switchPage = (
        values,
        setFieldValue,
        validateForm,
        errors,
        touched
    ) => {
        switch (page) {
            case 1:
                return (
                    <Page1
                        page={page}
                        setPage={setPage}
                        values={values}
                        setFieldValue={setFieldValue}
                        validateForm={validateForm}
                        errors={errors}
                        touched={touched}
                    />
                );
                break;
            case 2:
                return (
                    <Page2
                        page={page}
                        setPage={setPage}
                        values={values}
                        setFieldValue={setFieldValue}
                        validateForm={validateForm}
                        errors={errors}
                        touched={touched}
                    />
                );
                break;
            case 3:
                return (
                    <Page3
                        page={page}
                        setPage={setPage}
                        values={values}
                        setFieldValue={setFieldValue}
                        validateForm={validateForm}
                        errors={errors}
                        touched={touched}
                    />
                );
                break;
            case 4:
                return (
                    <Page4
                        page={page}
                        setPage={setPage}
                        values={values}
                        setFieldValue={setFieldValue}
                        validateForm={validateForm}
                        errors={errors}
                        touched={touched}
                    />
                );
                break;
            case "finish":
                return <Finish />;
            case "finish-save":
                return <FinishSave />;
        }
    };

    return (
        <div id='CompanyForm'>
            {page !== "finish" && page !== "finish-save" ? (
                <div className='big-title'>Unternehmensprofil ({page}/4)</div>
            ) : null}

            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values) => {
                    createCompany(values, setPage);
                }}>
                {({ values, setFieldValue, validateForm, errors, touched }) => (
                    <Form>
                        {switchPage(
                            values,
                            setFieldValue,
                            validateForm,
                            errors,
                            touched
                        )}
                    </Form>
                )}
            </Formik>
        </div>
    );
}
